import React, { memo } from 'react';

const TelegramIcon = (props) => (
    <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.93053 14.6342C3.93053 14.6342 14.2503 10.4268 17.8294 8.94525C19.2014 8.35268 23.8542 6.4563 23.8542 6.4563C23.8542 6.4563 26.0017 5.62671 25.8227 7.64152C25.763 8.4712 25.2859 11.3749 24.8087 14.5157C24.0928 18.9603 23.3173 23.8196 23.3173 23.8196C23.3173 23.8196 23.198 25.1826 22.184 25.4196C21.1699 25.6567 19.4996 24.59 19.2014 24.3529C18.9627 24.1752 14.7275 21.5084 13.1766 20.2047C12.759 19.8492 12.2818 19.1381 13.2362 18.3084C15.3837 16.3528 17.9487 13.9232 19.4996 12.3824C20.2155 11.6712 20.9312 10.012 17.9487 12.0268C13.7134 14.9306 9.5378 17.6565 9.5378 17.6565C9.5378 17.6565 8.58334 18.2491 6.79381 17.7158C5.0042 17.1825 2.91638 16.4713 2.91638 16.4713C2.91638 16.4713 1.48482 15.5824 3.93053 14.6342Z"
            fill="currentColor" />
    </svg>

);

export default memo(TelegramIcon);
